import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

import * as modifyAPI from '@api/modifyAPI'
import * as availabilityAPI from '@api/availability'
import * as types from '@store/mutation-types'
import { MessageBox } from 'element-ui';
import { UPDATE_ACCEPT_POLICY, UPDATE_CAKE, UPDATE_CONFIRMATION_CODE, UPDATE_EMAIL, UPDATE_OCCASION } from '../mutation-types'

const state = {
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  emailConfirmation: null,
  phone: null,
  phoneConfirmation: null,
  confirmationCode: null,
  cake: null,
  occasion: undefined,
  agreementsAccepted: false,
  resToken: null,
  resDeleted: false,
  validationFailure: [],
}

const mutations = {
  //update_info
  [ types.UPDATE_FIRST_NAME ]( state, val ) {
    state.firstName = val
  },
  [ types.UPDATE_LAST_NAME ]( state, val ) {
    state.lastName = val
  },
  [ types.UPDATE_PHONE ]( state, val ) {
    state.phone = val
  },
  [ types.UPDATE_PHONE_CONFIRMATION ]( state, val ) {
    state.phoneConfirmation = val
  },
  [ types.UPDATE_EMAIL ]( state, val ) {
    state.email = val
  },
  [ types.UPDATE_EMAIL_CONFIRMATION ]( state, val ) {
    state.emailConfirmation = val
  },
  [ types.UPDATE_CAKE ]( state, val ) {
    state.cake = val
  },
  [ types.UPDATE_OCCASION ]( state, val ) {
    state.occasion = val
  },
  [ types.UPDATE_ACCEPT_POLICY ]( state, val ) {
    state.agreementsAccepted = val
  },
  [ types.UPDATE_CONFIRMATION_CODE ]( state, val ) {
    state.confirmationCode = val
  },
  [ types.CLEAR_VALIDATION_FAILURE ]( state ) {
    state.validationFailure = []
  },
  [ types.ADD_VALIDATION_FAILURE ]( state, val ) {
    state.validationFailure = val
  },
  /////////////////////////   modify stuff below
  [ types.SET_RES_TOKEN ]( state, res_token ) {
    state.resToken = res_token
  },
  [ types.UPDATE_RES_DELETED ]( state, resDeleted ) {
    state.resDeleted = resDeleted
  }
}

function normalizePhone(phone) {
  var phoneDigits = ("" + phone).replace(/\D/g, '')

  if (phoneDigits.length == 7) { phoneDigits = "336" + phoneDigits }
  var m = phoneDigits.match(/^(\d{3})(\d{3})(\d{4})$/)
  return (!m) ? phone : m[1] + "-" + m[2] + "-" + m[3]
}

function validateName( name ) {
  return ((typeof name == 'string') && (name.length >= 1))
}

function validatePhone( phone ) {
  phone = ("" + phone).replace(/\D/g, '')
  return (typeof phone == "string" && phone.length==10)
}

function validatePhoneConfirmation( phone, phoneConfirmation ) {
  phone = ("" + phone).replace(/\D/g, '')
  phoneConfirmation = ("" + phoneConfirmation).replace(/\D/g, '')
  
  return phone == phoneConfirmation
}

function validatePartySize( partySize ) {
  return ( typeof partySize=="number" && partySize > 0 )
}

function validateEmail( email ) {
  return ( /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( email ) )
}

function validateEmailConfirmation( email, emailConfirmation ) {
  return email.toLowerCase() == emailConfirmation.toLowerCase()
}

const actions = {
  validate( {
    commit,
    state,
  } ) {
    commit( 'UPDATE_PHONE', normalizePhone( state.phone ) )
    let v = {}
    v[ 'firstName' ] = validateName( state.firstName )
    v[ 'lastName' ] = validateName( state.lastName )
    v[ 'phone' ] = validatePhone( state.phone )
    v[ 'phoneConfirmation' ] = validatePhoneConfirmation( state.phone, state.phoneConfirmation )
    v[ 'email' ] = validateEmail( state.email )
    v[ 'emailConfirmation' ] = validateEmailConfirmation( state.email, state.emailConfirmation )
    v[ 'policyAccepted' ] = state.agreementsAccepted

    commit( 'CLEAR_VALIDATION_FAILURE' )
    commit( 'ADD_VALIDATION_FAILURE', _.map( v, ( k, c ) => !k ? c : null ) )

    return _.every( v, x => x )
  },

  async completeBooking( {
    commit,
    state,
    rootState
  } ) {
    try {
      let resPacket = populateResPacket( state, rootState )
      let response = await availabilityAPI.bookRes( resPacket )
      // debugger
      if ( response.status != 200 ) {
        MessageBox( response.message )
        return false
      }

      if ( response.data.success == false ) {
        MessageBox( response.data.message )
        return false
      }

      if ( response.data.confirmation_code.length != 3 ) {
        return false
      }
      // whoa... code got messy fast
      commit( 'UPDATE_CONFIRMATION_CODE', response.data.confirmation_code )
      return ( response.status == 200 )
    } catch ( error ) {
      return false
    }
  },
  async getReservation( { commit, dispatch }, packet ) {
    commit( "SET_RES_TOKEN", packet.res_token )
    let response = await modifyAPI.getReservation( packet )
    
    if ( response.status == 200 ) {
      setResInfo( response.data, commit, dispatch )
    } else {
      commit( "UPDATE_RES_DELETED", true )
      // MessageBox( "Reservation is either not found, deleted or for past date." )
    }
  },
  async deleteReservation( { state, commit } ) {
    let response = await modifyAPI.deleteReservation( state.resToken )
    
    if ( response && response.status == 200 ) {
      commit( "UPDATE_RES_DELETED", true )
    } else {
      MessageBox( "Something went wrong. Your reservation was not cancelled." )
    }
  },
  modifyReservation( { state, commit, dispatch } ) {
    dispatch( "availability/showReservationCreator", null, { root: true } )
  }

}

function setResInfo( info, commit, dispatch ) {
  commit( "UPDATE_RES_DELETED", info.deleted ) // if already deleted, then display message

  commit( "SET_RES_TOKEN", info.token )
  commit( "UPDATE_FIRST_NAME", info.user.first_name )
  commit( "UPDATE_LAST_NAME", info.user.name )
  commit( "UPDATE_PHONE", info.user.phone )
  commit( "UPDATE_EMAIL", info.user.email )
  commit( "UPDATE_CAKE", ( parseInt( info.cake ) > 0 ).toString() )

  let parsedSong = JSON.parse( info.song )
  let songKeys = Object.keys( parsedSong )
  let occasion = null
  if ( songKeys.length > 0 ) {
    occasion = songKeys[0]
    if ( occasion == "otherOccasion" ) {
      occasion = "occasion"
    }
  }
  
  commit( "UPDATE_OCCASION", occasion )
  commit( "UPDATE_CONFIRMATION_CODE", info.confirmation_code )
  
  dispatch( "availability/setResInfo", {
    location: info.timeslot.schedule.location,
    date: info.timeslot.schedule.date,
    partySize: info.party_size,
    time: info.timeslot.timeslot
  }, { root: true } )
}

function populateResPacket( state, rootState ) {
  return {
    date: moment( rootState.availability.date ).format( 'MM-DD-YYYY' ),
    time: rootState.availability.suggestedTimes.selected,
    location: rootState.availability.location,
    party_size: rootState.availability.partySize,
    res_token: state.resToken,
    first_name: state.firstName,
    last_name: state.lastName,
    phone: state.phone,
    email: state.email,
    occasion: state.occasion,
    cake: state.cake,
    agreements_accepted: state.agreementsAccepted,
  }
}

export default {
  state,
  // getters,
  actions,
  mutations,
  namespaced: true
}